"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResponsiveSizes = exports.default = void 0;
var _react = require("react");
var _useUniversalLayoutEffect = _interopRequireDefault(require("./useUniversalLayoutEffect"));
var _useResizeObserver = require("./useResizeObserver");
const useResponsiveSizes = (callback, ref, {
  md = 600,
  lg = 1024,
  xl = 1440,
  xxl = 1920
}, containerBreakpoints) => {
  const [container, setContainer] = (0, _react.useState)(ref === null || ref === void 0 ? void 0 : ref.current);
  const getSizeName = size => {
    if (size < md) {
      return 'sm';
    }
    if (size >= md && size < lg) {
      return 'md';
    }
    if (size >= lg && size < xl) {
      return 'lg';
    }
    if (size >= xl && size < xxl) {
      return 'xl';
    }
    return 'xxl';
  };
  const handleResize = width => {
    var _a;
    if (containerBreakpoints) {
      if (container || width) {
        callback(getSizeName((container === null || container === void 0 ? void 0 : container.offsetWidth) || width));
      }
    } else {
      callback(getSizeName((_a = document === null || document === void 0 ? void 0 : document.documentElement) === null || _a === void 0 ? void 0 : _a.clientWidth));
    }
  };
  (0, _useResizeObserver.useResizeObserver)({
    onResize: ({
      width
    }) => {
      handleResize(width);
    },
    targetRef: ref,
    disconnect: !containerBreakpoints,
    skipStateUpdate: true
  });
  (0, _react.useEffect)(() => {
    setContainer(ref === null || ref === void 0 ? void 0 : ref.current);
    handleResize();
  }, [ref === null || ref === void 0 ? void 0 : ref.current]);
  (0, _useUniversalLayoutEffect.default)(() => {
    handleResize();
  }, []);
  (0, _react.useEffect)(() => {
    window.addEventListener('resize', () => handleResize());
    return () => {
      window.removeEventListener('resize', () => handleResize());
    };
  });
};
exports.useResponsiveSizes = useResponsiveSizes;
var _default = exports.default = useResponsiveSizes;